import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCoverflow } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-coverflow";
import { Link } from "react-router-dom";
import { api } from "../../services/api";
import { useContentList } from "../../hooks/useContent";
import { getImageUrl } from "../../utils/imageUrl";
import { useSiteContent, sectionField } from "../../hooks/useSiteContent";

const sliderOptions = {
  modules: [EffectCoverflow],
  effect: "coverflow",
  centeredSlides: true,
  slidesPerView: 1.15,
  initialSlide: 0,
  grabCursor: true,
  loop: true,
  speed: 1500,
  coverflowEffect: {
    rotate: 0,
    stretch: 95,
    depth: 212,
    modifier: 1,
  },
  breakpoints: {
    0: { slidesPerView: 1.15, coverflowEffect: { stretch: 0, depth: 80, modifier: 1 } },
    576: { slidesPerView: 2 },
    992: { slidesPerView: 3 },
    1200: { slidesPerView: 3 },
  },
};

function DestinationOne() {
  const [cursorActive, setCursorActive] = useState(false);
  const { items: destinations, loading, error } = useContentList(
    () => api.getDestinations({ per_page: 12 }),
    []
  );
  const { content } = useSiteContent("home");
  const subtitle = sectionField(content, "destinations", "subtitle", "Top Destination");
  const title = sectionField(content, "destinations", "title", "Popular Destination");
  const ctaText = sectionField(content, "destinations", "cta_text", "View");

  useEffect(() => {
    const sliderWrap = document.querySelector(".slider-drag-wrap");
    const sliderLink = document.querySelectorAll(".slider-drag-wrap a");

    const handleMouseEnter = () => setCursorActive(true);
    const handleMouseLeave = () => setCursorActive(false);

    if (sliderWrap) {
      sliderWrap.addEventListener("mouseenter", handleMouseEnter);
      sliderWrap.addEventListener("mouseleave", handleMouseLeave);
    }

    sliderLink.forEach((link) => {
      link.addEventListener("mouseenter", () => setCursorActive(false));
      link.addEventListener("mouseleave", () => setCursorActive(true));
    });

    return () => {
      if (sliderWrap) {
        sliderWrap.removeEventListener("mouseenter", handleMouseEnter);
        sliderWrap.removeEventListener("mouseleave", handleMouseLeave);
      }
    };
  }, [destinations]);

  if (!loading && !error && !destinations.length) {
    return null;
  }

  return (
    <div className="position-relative overflow-hidden">
      <div className="container">
        <div className="title-area text-center">
          <span className="sub-title">{subtitle}</span>
          <h2 className="sec-title">{title}</h2>
        </div>

        {loading && <p className="text-center">Loading destinations...</p>}
        {error && <p className="text-center text-danger">{error}</p>}

        {!loading && !error && destinations.length > 0 && (
          <div className={`slider-drag-wrap ${cursorActive ? "active" : ""}`}>
            <Swiper {...sliderOptions} className="destination-slider">
              {destinations.map((dest) => (
                <SwiperSlide key={dest.id}>
                  <div className="destination-box gsap-cursor">
                    <div className="destination-img">
                      <img src={getImageUrl(dest.image, "destination")} alt={dest.title} />
                      <div className="destination-content">
                        <div className="media-left">
                          <h4 className="box-title">
                            <Link to={`/destination/${dest.id}`}>{dest.title}</Link>
                          </h4>
                          <span className="destination-subtitle">{dest.price}</span>
                        </div>
                        <div>
                          <Link to={`/destination/${dest.id}`} className="th-btn style2 th-icon">
                            {ctaText}
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        )}
      </div>
    </div>
  );
}

export default DestinationOne;
